import React from "react";
import emptyDrawer from "../../../../assets/images/png/emptyDrawer.png";
import loaderGIF from "../../../../assets/images/gifs/loaderGIF.gif";

export default function EmptyScreen({ height = 500, loading = false }) {
  return (
    <div
      style={{
        height: height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      {!loading ? (
        <>
          <img
            className="empty-drawer-icon"
            src={emptyDrawer}
            alt="empty-screen"
          />
          <div className="empty-screen-text">
            You do not have any investments to display
          </div>
        </>
      ) : (
        <img
          className=""
          style={{ height: 40, width: 40 }}
          src={loaderGIF}
          alt="loading..."
        />
      )}
    </div>
  );
}
